<div class="ldh-container">

  <!-- ── Barre d'actions ── -->
  <div class="ldh-toolbar">
    <button class="ldh-toggle-filter-btn" (click)="showFilters = !showFilters" [class.active]="showFilters">
      <i class="fa fa-filter"></i> Filtres
      <i class="fa fa-chevron-down ldh-chevron" [class.rotated]="showFilters"></i>
    </button>
    <button class="hospit-new-btn" (click)="onNouvelleDemandeClick.emit()">
      <i class="fas fa-plus-circle"></i> Nouvelle demande
    </button>
    <span class="ldh-filter-count">{{ totalItems }} résultat(s)</span>
  </div>

  <!-- ── Filtres (masqués par défaut) ── -->
  @if (showFilters) {
  <div class="ldh-filters">
    <div class="ldh-filter-benef">
      <input type="text" class="ldh-filter-input" [(ngModel)]="filterMatricule" placeholder="Matricule assuré..."
        (keyup.enter)="search()">
    </div>
    <div class="ldh-filter-date-range">
      <span class="ldh-filter-date-label"><i class="fa fa-calendar"></i> Du</span>
      <input type="date" [(ngModel)]="filterDateDebut" class="ldh-filter-date" (change)="search()">
      <span class="ldh-filter-date-label">au</span>
      <input type="date" [(ngModel)]="filterDateFin" class="ldh-filter-date" (change)="search()">
    </div>
    <select [(ngModel)]="filterType" class="ldh-filter-select">
      <option value="">Tous les types</option>
      <option value="HM">Médicale (HM)</option>
      <option value="HC">Chirurgicale (HC)</option>
      <option value="MEO">Mise en observation (MEO)</option>
    </select>
    <select [(ngModel)]="filterStatut" class="ldh-filter-select">
      <option value="">Tous les statuts</option>
      <option value="pending">En attente</option>
      <option value="validated">Validé</option>
      <option value="rejected">Rejeté</option>
    </select>
    <button class="ldh-filter-search-btn" (click)="search()">
      <i class="fa fa-search"></i> Rechercher
    </button>
    <button class="ldh-filter-reset" (click)="resetFilters(); search()" title="Réinitialiser">
      <i class="fa fa-times"></i> Effacer
    </button>
  </div>
  }

  <!-- ── Table ── -->
  <div class="ldh-table-wrap">
    <table class="ldh-table">
      <thead>
        <tr>
          <th class="col-num">
            # <i class="fa fa-redo ldh-refresh" (click)="getItemsDemandeHospitalisationActive()" title="Actualiser"></i>
          </th>
          <th>Assuré(e)</th>
          <th class="col-type">Type</th>
          <th>Raison</th>
          <th class="col-date">Date dem.</th>
          <th class="col-date">D. entrée</th>
          <th class="col-date">D. sortie prév.</th>
          <th class="col-date">Démarrage</th>
          <th class="col-statut">Statut</th>
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (item of itemsDemandeFiltered; track item.id; let i = $index) {
        <tr [class.row-active]="item.is_active">
          <td class="col-num">{{ i + 1 }}</td>
          <td>
            <div class="ldh-assure-name">{{ item.beneficiaire_nom || '—' }} {{ item.beneficiaire_prenom || '' }}</div>
            <div class="ldh-assure-mat" *ngIf="item.beneficiaire_matricule">{{ item.beneficiaire_matricule }}</div>
          </td>
          <td class="col-type">
            <span class="ldh-type-badge ldh-type-{{ (item.type_hospitalisation_codification || '').toLowerCase() }}">
              {{ item.type_hospitalisation_codification }}
            </span>
          </td>
          <td class="col-raison">{{ item.raison_hospitalisation_libelle }}</td>
          <td class="col-date">{{ item.created_at | date:'dd/MM/yyyy' }}</td>
          <td class="col-date">{{ item.date_entree ? (item.date_entree | date:'dd/MM/yyyy') : '—' }}</td>
          <td class="col-date">{{ item.date_sortie_previsionnelle ? (item.date_sortie_previsionnelle |
            date:'dd/MM/yyyy') : '—' }}</td>
          <td class="col-date">
            @if (item.date_demarrage) {
            <span class="ldh-demarrage-info">
              <i class="fa fa-play-circle text-success"></i>
              {{ item.date_demarrage | date:'dd/MM/yyyy HH:mm' }}
            </span>
            } @else {
            <span class="text-muted">—</span>
            }
          </td>
          <td class="col-statut">
            @if (item.is_annule) {
            <span class="ldh-badge annule"><i class="fa fa-ban"></i> Annulé</span>
            } @else if (item.is_rejected) {
            <span class="ldh-badge rejected"><i class="fa fa-times-circle"></i> Rejeté</span>
            } @else if (item.date_demarrage && !item.date_sortie) {
            <span class="ldh-badge encours"><i class="fa fa-spinner fa-spin"></i> En cours</span>
            } @else if (item.date_demarrage && item.date_sortie) {
            <span class="ldh-badge demarré"><i class="fa fa-check-circle"></i> Clôturé</span>
            } @else if (item.is_validated) {
            <span class="ldh-badge validated"><i class="fa fa-check-circle"></i> Validé</span>
            } @else {
            <span class="ldh-badge pending"><i class="fa fa-clock"></i> En attente</span>
            }
          </td>
          <td class="col-actions">
            <div class="ldh-action-btns">
              <button class="ldh-btn-detail" (click)="openDetailModal(item); $event.stopPropagation()" title="Détail">
                <i class="fa fa-eye"></i>
              </button>
              @if (item.date_demarrage && !item.is_annule && !item.date_sortie) {
              <button class="ldh-btn-acte" (click)="openHubModal(item, 'prescrire'); $event.stopPropagation()"
                title="Soins">
                <i class="fa fa-plus-circle"></i> Soin
              </button>
              }
              @if (item.type_hospitalisation_codification === 'HM' && item.date_demarrage && canProroge(item) &&
              !item.date_sortie) {
              <button class="ldh-btn-proroge" (click)="openProrogationModal(item); $event.stopPropagation()"
                title="Prorogation">
                <i class="fa fa-calendar-plus"></i> Proroge
              </button>
              }
              @if (item.date_demarrage && !item.is_annule) {
              <button class="ldh-btn-decompte" (click)="openDecompteModal(item); $event.stopPropagation()"
                title="Décompte">
                <i class="fa fa-file-invoice"></i> Décompte
              </button>
              }
              @if (item.type_hospitalisation_codification === 'HM' && item.date_demarrage && !item.is_annule &&
              !item.date_sortie) {
              <button class="ldh-btn-fin-hospit" (click)="openFinHospitModal(item); $event.stopPropagation()"
                title="Clôturer l'hospitalisation">
                <i class="fa fa-flag-checkered"></i> Fin hospit
              </button>
              }
              @if (item.is_validated && !item.is_rejected && !item.date_demarrage && !item.is_annule) {
              <button class="ldh-btn-demarrer" (click)="demarrerHospit(item); $event.stopPropagation()"
                title="Démarrer l'hospitalisation">
                <i class="fa fa-play-circle"></i> Démarrer
              </button>
              }
              @if (!item.date_demarrage && !item.is_annule && !item.is_rejected) {
              <button class="ldh-btn-annuler" (click)="annulerHospit(item); $event.stopPropagation()"
                title="Annuler l'hospitalisation">
                <i class="fa fa-ban"></i> Annuler
              </button>
              }
            </div>
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="9" class="ldh-empty">
            <div class="ldh-empty-inner">
              <i class="fa fa-folder-open"></i>
              <span>Aucune donnée trouvée</span>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- ── Pagination ── -->
  <div class="paginator-wrap mt-2">
    <mat-paginator [length]="totalItems" [pageSize]="size" [pageIndex]="index" [pageSizeOptions]="[10, 25, 50]"
      (page)="onPageChange($event)" showFirstLastButtons>
    </mat-paginator>
  </div>

</div>

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Détail demande                           -->
<!-- ══════════════════════════════════════════════════ -->
@if (showDetailModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal ldh-modal-lg">

    <div class="ldh-modal-header">
      <span><i class="fa fa-eye me-2"></i>Détail de la demande — {{ selectedHospit?.codification }}</span>
      <button class="ldh-modal-close" (click)="closeDetailModal()"><i class="fa fa-times"></i></button>
    </div>

    <div class="ldh-modal-body">

      <!-- Statut banner -->
      <div class="ldh-detail-status-bar"
        [class.bar-validated]="selectedHospit?.is_validated && !selectedHospit?.is_rejected"
        [class.bar-rejected]="selectedHospit?.is_rejected"
        [class.bar-pending]="!selectedHospit?.is_validated && !selectedHospit?.is_rejected">
        @if (selectedHospit?.is_rejected) {
        <i class="fa fa-times-circle"></i> Rejeté
        } @else if (selectedHospit?.is_validated) {
        <i class="fa fa-check-circle"></i> Validé
        } @else {
        <i class="fa fa-clock"></i> En attente de validation
        }
      </div>

      <!-- Section assuré -->
      <div class="ldh-detail-section">
        <div class="ldh-detail-section-title"><i class="fa fa-user-circle me-1"></i>Assuré(e)</div>
        <div class="ldh-detail-grid">
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Nom complet</span>
            <span class="ldh-detail-value">{{ selectedHospit?.beneficiaire_nom }} {{ selectedHospit?.beneficiaire_prenom
              }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Matricule</span>
            <span class="ldh-detail-value mono">{{ selectedHospit?.beneficiaire_matricule || '—' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">N° CNAM</span>
            <span class="ldh-detail-value mono">{{ selectedHospit?.numero_cnam || '—' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Taux applicable</span>
            <span class="ldh-detail-value">{{ selectedHospit?.taux_applicable != null ? selectedHospit.taux_applicable +
              ' %' : '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Section hospitalisation -->
      <div class="ldh-detail-section">
        <div class="ldh-detail-section-title"><i class="fa fa-hospital me-1"></i>Hospitalisation</div>
        <div class="ldh-detail-grid">
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Type</span>
            <span class="ldh-detail-value">
              <span
                class="ldh-type-badge ldh-type-{{ (selectedHospit?.type_hospitalisation_codification || '').toLowerCase() }}">
                {{ selectedHospit?.type_hospitalisation_codification }}
              </span>
              {{ selectedHospit?.type_hospitalisation_libelle }}
            </span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Raison</span>
            <span class="ldh-detail-value">{{ selectedHospit?.raison_hospitalisation_libelle || '—' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Date demande</span>
            <span class="ldh-detail-value">{{ selectedHospit?.created_at | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Date entrée</span>
            <span class="ldh-detail-value">{{ selectedHospit?.date_entree ? (selectedHospit.date_entree |
              date:'dd/MM/yyyy') : '—' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Date sortie prév.</span>
            <span class="ldh-detail-value">{{ selectedHospit?.date_sortie_previsionnelle ?
              (selectedHospit.date_sortie_previsionnelle | date:'dd/MM/yyyy') : '—' }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Durée prév.</span>
            <span class="ldh-detail-value">{{ selectedHospit?.nombre_jours != null ? selectedHospit.nombre_jours + '
              jour(s)' : '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Section médecin / prestataire -->
      <div class="ldh-detail-section">
        <div class="ldh-detail-section-title"><i class="fa fa-user-md me-1"></i>Médecin / Prestataire</div>
        <div class="ldh-detail-grid">
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Médecin demandeur</span>
            <span class="ldh-detail-value">{{ selectedHospit?.medecin_nom || selectedHospit?.medecin_libelle || '—'
              }}</span>
          </div>
          <div class="ldh-detail-item">
            <span class="ldh-detail-label">Prestataire</span>
            <span class="ldh-detail-value">{{ selectedHospit?.prestataire_libelle || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Motif rejet si rejeté -->
      @if (selectedHospit?.is_rejected && selectedHospit?.motif_rejet) {
      <div class="ldh-detail-section ldh-detail-section-danger">
        <div class="ldh-detail-section-title"><i class="fa fa-ban me-1"></i>Motif de rejet</div>
        <p class="ldh-detail-motif">{{ selectedHospit?.motif_rejet }}</p>
      </div>
      }

    </div>

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeDetailModal()">Fermer</button>
      @if (selectedHospit?.date_demarrage && !selectedHospit?.is_annule && !selectedHospit?.date_sortie) {
      <button class="ldh-btn-acte btn-sm" (click)="closeDetailModal(); openHubModal(selectedHospit, 'prescrire')">
        <i class="fa fa-plus-circle"></i> Soin
      </button>
      }
      @if (selectedHospit?.type_hospitalisation_codification === 'HM') {
      <button class="ldh-btn-proroge btn-sm" (click)="closeDetailModal(); openProrogationModal(selectedHospit)">
        <i class="fa fa-calendar-plus"></i> Prorogation
      </button>
      }
    </div>
  </div>
</div>
}

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Ajouter un acte                          -->
<!-- ══════════════════════════════════════════════════ -->
@if (showActeModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal">

    <div class="ldh-modal-header">
      <span><i class="fa fa-plus-circle me-2"></i>Ajouter un acte — {{ selectedHospit?.codification }}</span>
      <button class="ldh-modal-close" (click)="closeActeModal()"><i class="fa fa-times"></i></button>
    </div>

    <div class="ldh-modal-body">
      <!-- Résumé demande -->
      <div class="ldh-resume-strip">
        <span class="ldh-resume-item"><strong>Bénéficiaire :</strong> {{ selectedHospit?.beneficiaire_nom }} {{
          selectedHospit?.beneficiaire_prenom }}</span>
        <span class="ldh-resume-item"><strong>Type :</strong> {{ selectedHospit?.type_hospitalisation_codification
          }}</span>
        <span class="ldh-resume-item"><strong>Entrée :</strong> {{ selectedHospit?.date_entree | date:'dd/MM/yyyy'
          }}</span>
        <span class="ldh-resume-item"><strong>Sortie prév. :</strong> {{ selectedHospit?.date_sortie_previsionnelle |
          date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="row g-2 mt-2">
        <!-- Acte -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label required"><i class="fas fa-procedures me-1"></i>Acte
              médical</label>
            <div class="col-8">
              <ng-select [items]="itemsActe" bindLabel="libelle" bindValue="id" [(ngModel)]="itemActe.acte_id"
                [searchable]="true" [clearable]="true" placeholder="Sélectionnez un acte"
                (change)="onSelectActeHospit()">
              </ng-select>
            </div>
          </div>
        </div>

        <!-- Médecin -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label required"><i class="fas fa-user-md me-1"></i>Médecin</label>
            <div class="col-8">
              <ng-select [items]="itemsPraticien" bindLabel="full_name" bindValue="id" [(ngModel)]="itemActe.medecin_id"
                placeholder="Sélectionnez le praticien">
              </ng-select>
            </div>
          </div>
        </div>

        <!-- Montant total -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label"><i class="fas fa-coins me-1"></i>Montant</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" disabled [value]="itemActe.montant || 0">
            </div>
          </div>
        </div>

        <!-- Part patient -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label"><i class="fas fa-user me-1"></i>Part patient</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" disabled [value]="itemActe.part_patient || 0">
            </div>
          </div>
        </div>

        <!-- Part assurance -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label"><i class="fas fa-shield-alt me-1"></i>Part assurance</label>
            <div class="col-8">
              <input type="text" class="form-control form-control-sm" disabled [value]="itemActe.part_assurance || 0">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeActeModal()">Annuler</button>
      <button class="btn btn-primary btn-sm" (click)="saveActe()"
        [disabled]="!itemActe.acte_id || !itemActe.medecin_id">
        <i class="fa fa-save me-1"></i>Enregistrer
      </button>
    </div>
  </div>
</div>
}

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Hub activités (soins hospit)             -->
<!-- ══════════════════════════════════════════════════ -->
@if (showHubModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal ldh-modal-hospit-hub">

    <!-- Header hub -->
    <div class="ldh-modal-header">
      <span>
        <i class="fa fa-hospital me-2"></i>
        {{ selectedHospit?.beneficiaire_nom }} {{ selectedHospit?.beneficiaire_prenom }}
        <span class="ldh-hub-mat">({{ selectedHospit?.matricule }})</span>
      </span>
      <button class="ldh-modal-close" (click)="closeHubModal()"><i class="fa fa-times"></i></button>
    </div>

    <!-- Onglets -->
    <div class="ldh-hub-tabs">
      <button class="ldh-hub-tab" [class.active]="activeHubTab === 'prescrire'" (click)="switchHubTab('prescrire')">
        <i class="fa fa-plus-circle me-1"></i> Prescrire
      </button>
      <button class="ldh-hub-tab" [class.active]="activeHubTab === 'suivi'" (click)="switchHubTab('suivi')">
        <i class="fa fa-list-alt me-1"></i> Suivi prestations
      </button>
    </div>

    <!-- Tab Prescrire -->
    @if (activeHubTab === 'prescrire') {
    <div class="ldh-hub-body">
      <app-prescription-hub
        [consultation]="{ id: selectedHospit?.id, beneficiaire_id: selectedHospit?.beneficiaire_id, matricule: selectedHospit?.matricule, praticien_id: null, dossier_id: null }"
        [beneficiaire]="{ nom: selectedHospit?.beneficiaire_nom, prenom: selectedHospit?.beneficiaire_prenom, matricule: selectedHospit?.matricule }"
        [hospitId]="selectedHospit?.id" [showAll]="true" (onClose)="closeHubModal()">
      </app-prescription-hub>
    </div>
    }

    <!-- Tab Suivi -->
    @if (activeHubTab === 'suivi') {
    <div class="ldh-hub-body ldh-hub-body-suivi">
      @if (isLoadingPrescriptions) {
      <div class="ldh-loading"><i class="fa fa-spinner fa-spin me-2"></i>Chargement...</div>
      } @else {
      <div class="ldh-suivi-actions">
        <span class="ldh-suivi-count">{{ selectedPrescIds.size }} sélectionné(s)</span>
        <select class="ldh-filter-garantie" [(ngModel)]="filterGarantiePresc"
          (ngModelChange)="onFilterGarantieChange()">
          <option [ngValue]="null">Toutes les garanties</option>
          @for (g of itemsGarantiePresc; track g.id) {
          <option [ngValue]="g.id">{{ g.libelle }}</option>
          }
        </select>
        <button class="ldh-btn-toggle-detail" [class.active]="filterTodayOnly"
          (click)="filterTodayOnly = !filterTodayOnly" title="Afficher uniquement les prestations d'aujourd'hui">
          <i class="fa fa-calendar-day"></i> {{ filterTodayOnly ? "Aujourd'hui" : 'Toutes' }}
        </button>
        <button class="ldh-btn-executer-sel" [disabled]="!selectedPrescIds.size" (click)="executerSelection()">
          <i class="fa fa-play"></i> Exécuter la sélection
        </button>
        <button class="ldh-btn-refresh" (click)="loadPrescriptionsHospit()">
          <i class="fa fa-sync-alt"></i> Actualiser
        </button>
      </div>
      <table class="ldh-table">
        <thead>
          <tr>
            <th style="width:36px;">
              <input type="checkbox" [checked]="allPrescSelected" [disabled]="!allPrescSelectables.length"
                (change)="toggleAllPresc()" />
            </th>
            <th>#</th>
            <th>Libellé</th>
            <th>Type</th>
            <th class="text-end">Prix sys.</th>
            <th class="text-end">Prix unit.</th>
            <th class="text-center">Qté</th>
            <th class="text-end">Montant</th>
            <th class="text-end">Part ass.</th>
            <th class="text-end">Part pat.</th>
            <th class="text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (p of prescriptionsFiltered; track p.id; let i = $index) {
          <tr [class.ldh-row-selected]="selectedPrescIds.has(p.id)"
            [class.ldh-row-blocked]="!isPrescSelectable(p) && !p.is_executed && !p.is_factured">
            <td>
              @if (isPrescSelectable(p)) {
              <input type="checkbox" [checked]="selectedPrescIds.has(p.id)" (change)="togglePresc(p)" />
              }
            </td>
            <td>{{ i + 1 }}</td>
            <td>{{ p.libelle || p.acte_libelle || p.medicament_libelle || '—' }}</td>
            <td><span class="ldh-type-badge">{{ p.garantie_codification || '—' }}</span></td>
            <td class="text-end" style="color:#6b7280;font-size:11px;">{{ p.prix_systeme ? (p.prix_systeme |
              IntegerFormatPipe) : '—' }}</td>
            <td>
              @if (!p.is_executed && !p.is_factured) {
              <input type="number" class="ldh-input-inline" [(ngModel)]="p._prix_unitaire"
                (ngModelChange)="onPrescPrixChange(p)" min="0" />
              } @else { <span class="text-end d-block">{{ p.prix_unitaire | IntegerFormatPipe }}</span> }
            </td>
            <td>
              @if (!p.is_executed && !p.is_factured) {
              <input type="number" class="ldh-input-inline" [(ngModel)]="p._quantite"
                (ngModelChange)="onPrescQteChange(p)" min="1" />
              } @else { {{ p.quantite || 1 }} }
            </td>
            <td class="text-end">{{ p._montant | IntegerFormatPipe }}</td>
            <td class="text-end" style="color:#1e40af;">{{ p._part_assurance | IntegerFormatPipe }}</td>
            <td class="text-end" style="color:#b45309;">{{ p._part_patient | IntegerFormatPipe }}</td>
            <td class="text-center">
              @if (p.is_executed || p.is_factured) {
              <span class="ldh-badge encours"><i class="fa fa-check"></i> Exécuté</span>
              } @else if (p.is_exclu) {
              <span class="ldh-badge exclu"><i class="fa fa-ban"></i> Exclu (100% patient)</span>
              } @else if (p.is_entente_prealable) {
              <span class="ldh-badge ep-pending"><i class="fa fa-hourglass-half"></i> EP en attente</span>
              } @else {
              <span class="ldh-badge garanti"><i class="fa fa-shield-alt"></i> Garanti</span>
              }
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="12" class="text-center py-3" style="color:#9ca3af;font-size:13px;">
              <i class="fa fa-folder-open me-1"></i> Aucune prescription trouvée
            </td>
          </tr>
          }
        </tbody>
      </table>
      }
    </div>
    }

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeHubModal()">Fermer</button>
    </div>

  </div>
</div>
}

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Fin hospit / Décompte sinistres          -->
<!-- ══════════════════════════════════════════════════ -->
@if (showFinHospitModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal ldh-modal-xl">

    <div class="ldh-modal-header ldh-modal-header-teal">
      <span><i class="fa fa-flag-checkered me-2"></i>Clôture hospit — {{ selectedHospit?.codification }} | {{
        selectedHospit?.beneficiaire_nom }} {{ selectedHospit?.beneficiaire_prenom }}</span>
      <button class="ldh-modal-close" (click)="closeFinHospitModal()"><i class="fa fa-times"></i></button>
    </div>

    <div class="ldh-modal-body">

      <!-- Résumé hospit -->
      <div class="ldh-resume-strip ldh-resume-teal mb-3">
        <span class="ldh-resume-item"><strong>Entrée :</strong> {{ selectedHospit?.date_entree | date:'dd/MM/yyyy'
          }}</span>
        <span class="ldh-resume-item"><strong>Sortie prév. :</strong> {{ selectedHospit?.date_sortie_previsionnelle |
          date:'dd/MM/yyyy' }}</span>
        <span class="ldh-resume-item"><strong>Taux applicable :</strong> {{ selectedHospit?.taux_applicable }} %</span>
      </div>

      <!-- Liste sinistres -->
      @if (isLoadingSinistres) {
      <div class="ldh-loading"><i class="fa fa-spinner fa-spin me-2"></i>Chargement des sinistres...</div>
      } @else if (!itemsSinistreHospit.length) {
      <div class="ldh-empty-inner"><i class="fa fa-folder-open"></i><span>Aucun sinistre trouvé pour cette
          hospitalisation</span></div>
      } @else {
      <table class="ldh-table mb-0">
        <thead>
          <tr>
            <th style="width:32px;"></th>
            <th>Libellé</th>
            <th>Date</th>
            <th class="text-end">Montant remb.</th>
            <th class="text-end">Part assurance</th>
            <th class="text-end">Part patient</th>
            <th class="text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (s of itemsSinistreHospit; track s.id; let i = $index) {
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ s.acte_libelle || s.libelle || '—' }}</td>
            <td>{{ s.created_at | date:'dd/MM/yyyy' }}</td>
            <td class="text-end">{{ s.montant_remboursable | IntegerFormatPipe }}</td>
            <td class="text-end">{{ s.part_assurance | IntegerFormatPipe }}</td>
            <td class="text-end">{{ s.part_patient | IntegerFormatPipe }}</td>
            <td class="text-center">
              <span class="ldh-badge" [ngClass]="{
                  'encours': s.statut === 'ENCOURS_HOSPIT',
                  'pending': s.statut === 'ATTENTE_PREVALIDATION_PRESTATAIRE',
                  'validated': s.statut === 'DECOMPTE_SINISTRE' || s.statut === 'VALIDE_GESTIONNAIRE'
                }">{{ s.statut }}</span>
            </td>
          </tr>
          }
        </tbody>
        <tfoot>
          <tr class="ldh-tfoot-total">
            <td colspan="3"><strong>TOTAL</strong></td>
            <td class="text-end"><strong>{{ totalMontantSinistres | IntegerFormatPipe }}</strong></td>
            <td class="text-end"><strong>{{ totalPartAssuranceSinistres | IntegerFormatPipe }}</strong></td>
            <td class="text-end"><strong>{{ totalPartPatientSinistres | IntegerFormatPipe }}</strong></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      }
    </div>

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeFinHospitModal()">Fermer</button>
      @if (itemsSinistreHospit.length) {
      <button class="ldh-btn-fin-hospit btn-sm" (click)="envoyerEnPrevalidation()"
        [disabled]="!itemsSinistreHospit.length">
        <i class="fa fa-paper-plane me-1"></i>Envoyer en prévalidation &amp; clôturer
      </button>
      }
    </div>
  </div>
</div>
}

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Décompte prestations                     -->
<!-- ══════════════════════════════════════════════════ -->
@if (showDecompteModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal ldh-modal-hospit-hub">

    <div class="ldh-modal-header ldh-modal-header-blue">
      <span><i class="fa fa-file-invoice me-2"></i>Décompte — {{ selectedHospit?.codification }} | {{
        selectedHospit?.beneficiaire_nom }} {{ selectedHospit?.beneficiaire_prenom }}</span>
      <button class="ldh-modal-close" (click)="closeDecompteModal()"><i class="fa fa-times"></i></button>
    </div>

    <div class="ldh-modal-body">

      <div class="ldh-resume-strip ldh-resume-blue mb-3">
        <span class="ldh-resume-item"><strong>Entrée :</strong> {{ selectedHospit?.date_entree | date:'dd/MM/yyyy'
          }}</span>
        <span class="ldh-resume-item"><strong>Sortie prév. :</strong> {{ selectedHospit?.date_sortie_previsionnelle |
          date:'dd/MM/yyyy' }}</span>
        <span class="ldh-resume-item"><strong>Type :</strong> {{ selectedHospit?.type_hospitalisation_codification
          }}</span>
        <span class="ldh-resume-item"><strong>Taux :</strong> {{ selectedHospit?.taux_applicable }} %</span>
      </div>

      @if (isLoadingSinistres) {
      <div class="ldh-loading"><i class="fa fa-spinner fa-spin me-2"></i>Chargement...</div>
      } @else if (!itemsSinistreHospit.length) {
      <div class="ldh-empty-inner"><i class="fa fa-folder-open"></i><span>Aucune prestation enregistrée</span></div>
      } @else {
      <div class="ldh-decompte-toolbar mb-2">
        <span class="ldh-decompte-count">{{ itemsSinistreHospit.length }} prestation(s)</span>
      </div>
      <table class="ldh-table mb-0">
        <thead>
          <tr>
            <th style="width:32px;"></th>
            <th>Libellé</th>
            <th>Date</th>
            <th class="text-end">Montant remb.</th>
            <th class="text-end">Part assurance</th>
            <th class="text-end">Dépassement</th>
            <th class="text-end">Part patient</th>
            <th class="text-center">Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (s of itemsSinistreHospit; track s.id; let i = $index) {
          <tr>
            <td>
              <button class="ldh-btn-expand" (click)="toggleSinistreDetail(s)"
                [title]="s._expanded ? 'Masquer' : 'Voir détail'">
                <i class="fa" [class.fa-plus]="!s._expanded" [class.fa-minus]="s._expanded"></i>
              </button>
            </td>
            <td>{{ s.acte_libelle || s.libelle || '—' }}</td>
            <td>{{ s.created_at | date:'dd/MM/yyyy' }}</td>
            <td class="text-end">{{ s.montant_remboursable | IntegerFormatPipe }}</td>
            <td class="text-end">{{ s.part_assurance | IntegerFormatPipe }}</td>
            <td class="text-end">
              @if (s.depassement > 0) {
              <span style="color:#92400e;font-weight:600;">{{ s.depassement | IntegerFormatPipe }}</span>
              } @else { <span style="color:#9ca3af;">—</span> }
            </td>
            <td class="text-end">{{ s.part_patient | IntegerFormatPipe }}</td>
            <td class="text-center">
              <span class="ldh-badge" [ngClass]="{
                  'encours': s.statut === 'ENCOURS_HOSPIT',
                  'pending': s.statut === 'ATTENTE_PREVALIDATION_PRESTATAIRE',
                  'validated': s.statut === 'DECOMPTE_SINISTRE' || s.statut === 'VALIDE_GESTIONNAIRE'
                }">{{ s.statut }}</span>
            </td>
          </tr>
          @if (s._expanded) {
          <tr class="ldh-detail-row">
            <td></td>
            <td colspan="7">
              @if (s._loadingDetail) {
              <div class="ldh-loading-sm"><i class="fa fa-spinner fa-spin me-1"></i> Chargement...</div>
              } @else if (!s._prestations?.length) {
              <div class="ldh-empty-sm">Aucun détail disponible</div>
              } @else {
              <table class="ldh-subtable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Libellé</th>
                    <th>Garantie</th>
                    <th class="text-end">Qté</th>
                    <th class="text-end">Prix unit.</th>
                    <th class="text-end">Montant</th>
                    <th class="text-end">Part ass.</th>
                    <th class="text-end">Part pat.</th>
                  </tr>
                </thead>
                <tbody>
                  @for (pa of s._prestations; track pa.id; let j = $index) {
                  <tr>
                    <td>{{ j + 1 }}</td>
                    <td>{{ pa.acte_libelle || pa.medicament_libelle || pa.libelle || '—' }}</td>
                    <td>{{ pa.garantie_codification || '—' }}</td>
                    <td class="text-end">{{ pa.quantite || 1 }}</td>
                    <td class="text-end">{{ pa.prix_unitaire | IntegerFormatPipe }}</td>
                    <td class="text-end">{{ pa.montant | IntegerFormatPipe }}</td>
                    <td class="text-end" style="color:#1e40af;">{{ pa.part_assurance | IntegerFormatPipe }}</td>
                    <td class="text-end" style="color:#b45309;">{{ pa.part_patient | IntegerFormatPipe }}</td>
                  </tr>
                  }
                </tbody>
              </table>
              }
            </td>
          </tr>
          }
          }
        </tbody>
        <tfoot>
          <tr class="ldh-tfoot-total">
            <td colspan="3"><strong>TOTAL</strong></td>
            <td class="text-end"><strong>{{ totalMontantSinistres | IntegerFormatPipe }}</strong></td>
            <td class="text-end"><strong>{{ totalPartAssuranceSinistres | IntegerFormatPipe }}</strong></td>
            <td class="text-end">
              @if (totalDepassementSinistres > 0) {
                <strong style="color:#92400e;">{{ totalDepassementSinistres | IntegerFormatPipe }}</strong>
              } @else { <span style="color:#9ca3af;">—</span> }
            </td>
            <td class="text-end"><strong>{{ totalPartPatientSinistres | IntegerFormatPipe }}</strong></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      }
    </div>

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeDecompteModal()">Fermer</button>
    </div>
  </div>
</div>
}

<!-- ══════════════════════════════════════════════════ -->
<!--  MODAL — Demander une prorogation                 -->
<!-- ══════════════════════════════════════════════════ -->
@if (showProrogationModal) {
<div class="ldh-modal-backdrop">
  <div class="ldh-modal">

    <div class="ldh-modal-header ldh-modal-header-orange">
      <span><i class="fa fa-calendar-plus me-2"></i>Demande de prorogation — {{ selectedHospit?.codification }}</span>
      <button class="ldh-modal-close" (click)="closeProrogationModal()"><i class="fa fa-times"></i></button>
    </div>

    <div class="ldh-modal-body">
      <!-- Résumé demande actuelle -->
      <div class="ldh-resume-strip ldh-resume-orange mb-3">
        <span class="ldh-resume-item"><strong>Bénéficiaire :</strong> {{ selectedHospit?.beneficiaire_nom }} {{
          selectedHospit?.beneficiaire_prenom }}</span>
        <span class="ldh-resume-item"><strong>Type :</strong> {{ selectedHospit?.type_hospitalisation_codification
          }}</span>
        <span class="ldh-resume-item"><strong>Raison :</strong> {{ selectedHospit?.raison_hospitalisation_libelle
          }}</span>
        <span class="ldh-resume-item"><strong>Entrée :</strong> {{ selectedHospit?.date_entree | date:'dd/MM/yyyy'
          }}</span>
        <span class="ldh-resume-item"><strong>Sortie prév. :</strong> {{ selectedHospit?.date_sortie_previsionnelle |
          date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="row g-2">
        <!-- Nombre de jours -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label required"><i class="fas fa-calendar-day me-1"></i>Nb jours
              demandés</label>
            <div class="col-8">
              <input type="number" min="1" class="form-control form-control-sm" [(ngModel)]="itemProrogation.nb_jours"
                placeholder="Ex: 5">
            </div>
          </div>
        </div>

        <!-- Affection -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label required"><i
                class="fas fa-stethoscope me-1"></i>Affection</label>
            <div class="col-8">
              <ng-select [items]="itemsAffection" bindLabel="libelle" bindValue="id"
                [(ngModel)]="itemProrogation.affection_id" [searchable]="true" placeholder="Sélectionnez l'affection">
              </ng-select>
            </div>
          </div>
        </div>

        <!-- Raison de la demande -->
        <div class="col-12">
          <div class="row align-items-center gx-3">
            <label class="col-4 col-form-label form-label required"><i
                class="fas fa-comment-medical me-1"></i>Raison</label>
            <div class="col-8">
              <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="itemProrogation.raison"
                placeholder="Décrivez la raison de la demande de prorogation..."></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ldh-modal-footer">
      <button class="btn btn-secondary btn-sm" (click)="closeProrogationModal()">Annuler</button>
      <button class="btn btn-warning btn-sm text-white" (click)="saveProrogation()"
        [disabled]="!itemProrogation.nb_jours || !itemProrogation.affection_id || !itemProrogation.raison">
        <i class="fa fa-paper-plane me-1"></i>Soumettre la demande
      </button>
    </div>
  </div>
</div>
}